/**
 * utils
 *
 * Created by Samuel on 2022/10/1
 */

const quickCheck = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;

const charCodeOfDot = '.'.charCodeAt(0);
const reEscapeChar = /\\(\\)?/g;
const rePropName = RegExp(
	// Match anything that isn't a dot or bracket.
	'[^.[\\]]+' +
		'|' +
		// Or match property names within brackets.
		'\\[(?:' +
		// Match a non-string expression.
		'([^"\'][^[]*)' +
		'|' +
		// Or match strings (supports escaping characters).
		'(["\'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2' +
		')\\]' +
		'|' +
		// Or match "" as the space between consecutive dots or empty brackets.
		'(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))',
	'g',
);

const MAX_MEMOIZE_SIZE = 500;
const stringToPath = (string) => {
	const result = [];
	if (string.charCodeAt(0) === charCodeOfDot) {
		result.push('');
	}
	string.replace(rePropName, (match, expression, quote, subString) => {
		let key = match;
		if (quote) {
			key = subString.replace(reEscapeChar, '$1');
		} else if (expression) {
			key = expression.trim();
		}
		result.push(key);
	});

	const _res = result.join('.');

	// 超出最大限度后，进行缓存的清空
	if (stringToPath.cached.size === MAX_MEMOIZE_SIZE) {
		stringToPath.cached.clear();
	}

	stringToPath.cached.set(string, _res);

	return _res;
};
stringToPath.cached = new Map();

export const tokenNormalized = (str) => {
	if (quickCheck.test(str)) {
		if (stringToPath.cached.has(str)) {
			return stringToPath.cached.get(str);
		}
		return stringToPath(str);
	}
	return str;
};
